import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {LmConfigPage} from "../page/overview/lm-config/lm-config.page";
import {LmDashboardPage} from "../page/overview/lm-dashboard/lm-dashboard.page";


const lmModuleEntry: TestModuleDefinition = {
    key: 'lm',
    label: 'Lead (lm)',
    components: [
        {
            key: 'LmConfigPage',
            component: LmConfigPage,
            selector: 'mvs-lm-config',
            type: 'PageComponent',
            label: 'lm config page'
        },
        {
            key: 'LmDashboardPage',
            component: LmDashboardPage,
            selector: 'mvs-lm-dashboard-page',
            type: 'PageComponent',
            label: 'lm dashboard page'
        }
    ]
}

export const LM_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: lmModuleEntry, multi: true}
];